import { H1 } from "@components/utilities";
import { type TagBasedOrderExclusion } from "@north-beam/nb-common";
import { TertiaryButton } from "@shared/buttons";

import { TagBasedOrderRow } from "./order-tag-row";

type Props = {
  title: string;
  description?: string;
  subheader?: string;
  isSynced: boolean;
  loading: boolean;
  tagFilters: TagBasedOrderExclusion[];
  addButtonText?: string;
  updateTagFilters: any;
  createTagFilters: any;
  removeTagFilters: any;
};

export function OrderTagFilters({
  title,
  description,
  subheader,
  isSynced,
  loading,
  tagFilters,
  addButtonText = "ADD EXCLUSION",
  updateTagFilters,
  createTagFilters,
  removeTagFilters,
}: Props) {
  return (
    <div>
      {title && <H1>{title}</H1>}
      {subheader && <p>{subheader}</p>}
      <hr />
      {!loading && (
        <>
          {description && (
            <div className="font-bold text-lg">{description}</div>
          )}
          <div className="flex items-center space-x-2">
            <div>Sync status: </div>
            {isSynced ? (
              <i className="fa-regular fa-check text-alien" />
            ) : (
              <i className="fa-regular fa-spinner animate-spin" />
            )}
          </div>
          <div className="rounded-lg border border-gray-1 bg-white mt-3">
            <table className="w-full h-full">
              <thead>
                <tr className="border-b border-b-gray-2">
                  <th className="w-20">
                    <div className="border-r border-r-gray-2 my-2 px-2 text-xs">
                      Active?
                    </div>
                  </th>
                  <th className="w-32">
                    <div className="border-r border-r-gray-2 my-2 px-2 text-xs">
                      Tag type
                    </div>
                  </th>
                  <th className="w-32">
                    <div className="border-r border-r-gray-2 my-2 px-2 text-xs">
                      Logic
                    </div>
                  </th>
                  <th>
                    <div className="my-2 px-2 text-xs">Tag name</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {tagFilters.map((tagFilter, index) => (
                  <TagBasedOrderRow
                    tagFilter={tagFilter}
                    loading={loading}
                    key={`Exclusion-${index}`}
                    removeTagFilters={() => removeTagFilters(index)}
                    updateTagFilters={(updatedExclusion) =>
                      updateTagFilters(index, updatedExclusion)
                    }
                  />
                ))}
                <tr>
                  <td colSpan={2} className="py-1 px-2">
                    <TertiaryButton
                      className="uppercase flex items-center justify-center gap-2"
                      onClick={createTagFilters}
                    >
                      <i className="fa-regular fa-circle-plus" />
                      {addButtonText}
                    </TertiaryButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
      {loading && <>Please wait...</>}
    </div>
  );
}
